import React from 'react';

export const NoOpFormSubmitHandler = (e: React.FormEvent): void => {
  e.preventDefault();
};
